import { useEffect } from 'react';

import { Stack, Title } from '@mantine/core';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { WorkspaceSettingsHeader } from '../../features/workspaceSettings/components/WorkspaceSettingsHeader';
import { WorkspaceUserTable } from '../../features/workspaceSettings/components/WorkspaceUserTable';
import { FiltersProvider } from '../../features/workspaceSettings/hooks/useFilters.hook';
import { Permission } from '../../shared/entities/Access';
import { usePermission } from '../../shared/hooks/usePermission.hook';

export function WorkspaceSettingsPage() {
  const { t } = useTranslation('workspaceSettings');
  const { hasPermission } = usePermission();
  const navigate = useNavigate();

  useEffect(() => {
    if (!hasPermission(Permission.CREATE_USER)) {
      navigate('/');
    }
  }, [hasPermission, navigate]);

  return (
    <FiltersProvider>
      <Stack
        p="05"
        spacing={0}
        sx={{
          background: 'linear-gradient(180deg, #EFF8FF -2.79%, #FFFFFF 2.09%)',
        }}
      >
        <Title mb="04" order={3} fw={500} c="gray.9">
          {t('title')}
        </Title>

        <WorkspaceSettingsHeader />
        <WorkspaceUserTable />
      </Stack>
    </FiltersProvider>
  );
}
